/// <amd-module name="Test/ManageTestPlans/Components/LoadingComponent" />

import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import * as React from "react";
import * as Resources from "Test/ManageTestPlans/Resources";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

export class LoadingComponent extends VssComponent<IVssComponentProperties, {}> {
    constructor(options?: any) {
        super(options);
    }

    public render(): JSX.Element {
        return <div className="loading-container">
            <Spinner size={SpinnerSize.large} label={Resources.Loading} />
        </div>;
    }
}
